import {ksuTwoTemplate} from './KsuTwoTemplate'
import {ksuTwoTemplateRtl} from './KsuTwoTemplateRTL'

export default {ksuTwoTemplate,ksuTwoTemplateRtl}